import youtube from "../images/YouTube_icon.png";

export default function Interview() {
  function video(activ) {
    return (
      <div className="vid">
        {activ ? (
          <a href="https://youtu.be/bXIXxrrr4l4" target="_blank">
            <img
              className="activ"
              src="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg"
              alt=""
            />
            <img className="play2" src={youtube} alt="" />
          </a>
        ) : (
          <a href="https://youtu.be/bXIXxrrr4l4" target="_blank">
            <img
              src="https://img.youtube.com/vi/bXIXxrrr4l4/hqdefault.jpg"
              alt=""
            />
            <img className="play" src={youtube} alt="" />
          </a>
        )}
        <br />
        <a href="https://youtu.be/bXIXxrrr4l4" target="_blank">
          Deogratius Interview
        </a>
      </div>
    );
  }
  return (
    <div>
      <div className="title">Recent Interviews</div>
      <div className="interview">
        {video()}
        {video(true)}
        {video()}
      </div>
    </div>
  );
}
